import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const ExtendSessionOutcomeDialog = ({
  open,
  onClose,
  variant,
  studentName,
  extensionMinutes,
  extensionFee,
}) => {
  const name = studentName || 'Learner';
  const mins = extensionMinutes ?? '—';
  const fee = extensionFee != null && extensionFee !== '' ? String(extensionFee) : null;

  const isSuccess = variant === 'success';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxWidth: 360,
          m: 2,
        },
      }}
    >
      <DialogContent sx={{ p: 3, pt: 2.5 }}>
        <Stack direction="row" justifyContent="flex-end" sx={{ mb: 0.5 }}>
          <IconButton size="small" onClick={onClose} aria-label="Close" sx={{ p: 0.25 }}>
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Stack>
        <Stack alignItems="center" spacing={2.75} sx={{ px: 1, pb: 1 }}>
          {isSuccess ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 80, color: '#14B334' }} />
          ) : (
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: '#FFDDDD',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CloseRoundedIcon sx={{ fontSize: 40, color: '#E14949' }} />
            </Box>
          )}
          <Box sx={{ textAlign: 'center', maxWidth: 295 }}>
            <Typography
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 600,
                fontSize: 16,
                color: '#000',
                mb: 0.75,
              }}
            >
              {isSuccess ? 'Successful' : 'Rejected!'}
            </Typography>
            {isSuccess ? (
              <Typography
                component="div"
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: 1.43,
                  color: '#949DA6',
                }}
              >
                Your session with {name} has been extended for another {mins} mins.
                {fee ? (
                  <>
                    {' '}
                    <Box component="span" sx={{ color: '#0A5EF3', fontWeight: 400 }}>
                      {fee} Koins
                    </Box>
                    <Box component="span" sx={{ color: '#949DA6' }}>
                      {' '}
                      have been added to your wallet.
                    </Box>
                  </>
                ) : null}
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: 1.43,
                  color: '#949DA6',
                  textAlign: 'center',
                }}
              >
                You rejected the request sent by {name} to extend your session for another {mins}{' '}
                mins.
              </Typography>
            )}
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ExtendSessionOutcomeDialog;
